import {
    faCameraMovie,
    faComments,
    faGraduationCap,
    faNewspaper,
    faTicket,
    faTrophy,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';

import Action from '../../Action';
import UserPicture from '../../Atoms/UserPicture';
import faBrickstarsPalm from '../../Icons/faBrickstarsPalm';
import UserMenu from '../UserMenu';

import * as style from './style.module.css';

const HeaderNavActions = ({
    contest = null,
    contestsToJudge = [],
    user = null,
    allowedActions = [],
    darkModeStatus = 'LIGHT',
    unreadChats = 0,
    unreadNotifications = 0,
    onSignOut = () => { },
    onLanguageChange = () => { },
    onThemeChange = () => { },
    t,
}) => {
    const indicator = (unreadChats || 0) + (unreadNotifications || 0);
    const [isMenuOpened, setIsMenuOpened] = useState(false);
    return <>
        <div className={style.container}>
            <Action action="/news/" className={style.category}>
                <FontAwesomeIcon icon={faNewspaper} />
                <span>{t('News')}</span>
            </Action>
            {contest && contest?.festival === null && <Action action={`/contests/${contest.id}/${contest.slug}`} className={`${style.category} ${style.contest}`}>
                <FontAwesomeIcon icon={contest.type === 'BRICKSTARS' ? faBrickstarsPalm : faTrophy} />
                <span>{contest.shortTitle}</span>
            </Action>}
            {contest && contest?.festival !== null && <Action action={`/festivals/${contest?.festival?.id}/${contest?.festival?.slug}`} className={`${style.category} ${style.contest}`}>
                <FontAwesomeIcon icon={faTicket} />
                <span>{contest.shortTitle}</span>
            </Action>}
            <Action action="/brickfilms/" className={style.category}>
                <FontAwesomeIcon icon={faCameraMovie} />
                <span>{t('Brickfilms')}</span>
            </Action>
            <Action action="/community/" className={style.category}>
                <FontAwesomeIcon icon={faComments} />
                <span>{t('Community')}</span>
            </Action>
            <Action action="/resources/" className={style.category}>
                <FontAwesomeIcon icon={faGraduationCap} />
                <span>{t('Resources')}</span>
            </Action>
            {user && <Action action={() => setIsMenuOpened(true)} className={`${style.category} ${style.profileAction}`}>
                {indicator > 0 && <span className={style.hint} />}
                <UserPicture {...user} title={t('User profile')} className={style.user} action={() => setIsMenuOpened(true)} animatedPicture={null} />
                <span>{t('You')}</span>
            </Action>}
        </div>
        {user && <UserMenu position="BOTTOM" unreadChats={unreadChats} unreadNotifications={unreadNotifications} contestsToJudge={contestsToJudge} onLanguageChange={onLanguageChange} onThemeChange={onThemeChange} darkModeStatus={darkModeStatus} allowedActions={allowedActions} isOpened={isMenuOpened} onClose={() => setIsMenuOpened(false)} onSignOut={onSignOut} user={user} />}
    </>
}


export default withTranslation()(HeaderNavActions);